/**
 * @generated SignedSource<<c6d7d5f5cf8057eeaccb68a67e39af54>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptionsContent_item$data = {
  readonly isCustomizable: boolean | null;
  readonly leadTimeDisplay: string | null;
  readonly seller: {
    readonly isJewelrySeller: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_item">;
  readonly " $fragmentType": "PdpSharedDescriptionAdditionalOptionsContent_item";
};
export type PdpSharedDescriptionAdditionalOptionsContent_item$key = {
  readonly " $data"?: PdpSharedDescriptionAdditionalOptionsContent_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAdditionalOptionsContent_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leadTimeDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isJewelrySeller",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5bda56f76f41757be069f9baf9e607ea";

export default node;
